var _title, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    style: {
      fill: "hsl(35, 100%, 50%)"
    },
    viewBox: "0 0 36 36",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "folder-open-line")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-1",
    d: "M35.32,13.74A1.71,1.71,0,0,0,33.87,13H11.17a2.59,2.59,0,0,0-2.25,1.52,1,1,0,0,0,0,.14L6,25V7h6.49l2.61,3.59a1,1,0,0,0,.81.41H32a2,2,0,0,0-2-2H16.42L14.11,5.82A2,2,0,0,0,12.49,5H6A2,2,0,0,0,4,7V29.69A1.37,1.37,0,0,0,5.41,31H30.34a1,1,0,0,0,1-.72l4.19-15.1A1.64,1.64,0,0,0,35.32,13.74ZM29.55,29H6.9l3.88-13.81a.66.66,0,0,1,.38-.24H33.49Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    fillOpacity: 0
  })));
}
export default __webpack_public_path__ + "assets/folder-open-line.svg";
export { SvgFolderOpenLine as ReactComponent };